import { LOCATION_CHANGE } from 'react-router-redux';
import update from 'immutability-helper';
import { APP } from '../constants';

export const initialState = {
  isLoading: false,
  notification: {
    visible: false,
    title: '',
    message: '',
    type: 'info',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP.SHOW_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case APP.HIDE_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case APP.NOTIFICATION.SHOW:
      return {
        ...state,
        notification: {
          visible: true,
          title: action.title,
          message: action.message,
          type: action.messageType,
          notificationType: action.notificationType,
        },
      };
    case APP.NOTIFICATION.UPDATE:
      return {
        ...state,
        notification: {
          ...action.newParams,
        },
      };
    case APP.NOTIFICATION.CLOSE:
    case LOCATION_CHANGE:
      return update(state, {
        notification: {
          visible: { $set: false },
          title: { $set: '' },
          message: { $set: '' },
        },
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/app.reducer.js